import { getAccessToken } from "@newsenec/auth-provider";
import { buildFetchErrorMessage } from "@newsenec/logging";

export const sendVerificationEmail = async () => {
    const token = await getAccessToken();
    const url = new URL(`${location.origin}/api/fpp/verificationMail`);
    const method = "POST";

    const response = await fetch(url, {
        method,
        headers: {
            Authorization: "Bearer " + token,
        },
    });

    if (!response.ok) return Promise.reject(new Error(buildFetchErrorMessage(method, response)));

    return Promise.resolve();
};
